module.exports = __webpack_public_path__ + "img/kinesis-sport-logo.da12ebeb.png";